import { ExpenseData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const expensesApi = apiResource<ExpenseData>('expenses');
